module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "header_dropzone"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }],
    staticClass: "overlay"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav__left"
  }, [_c('li', [_c('span', {
    on: {
      "!click": function($event) {
        return _vm.clicked.apply(null, arguments)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/admin"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("./assets/pleiades_logo.png"),
      "alt": "logo"
    }
  })])])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('ul', {
    staticClass: "nav__right"
  }, [_c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "grey_text dis_blk"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.welcome")))]), _vm._v(" "), _c('span', {
    staticClass: "fntRoboto"
  }, [_vm._v(_vm._s(_vm.userId)), _c('span', {
    staticClass: "grey_text_author"
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "grey_text dis_blk fntRoboto"
  }, [_vm._v(_vm._s(_vm.$t("message.front_page.select_lang")))]), _vm._v(" "), _c('span', {
    staticClass: "blue_text fntRoboto",
    attrs: {
      "id": "langDropdown"
    }
  }, [_c('select', {
    on: {
      "change": _vm.onDrpChange
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")]), _c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("русский")])])])])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "loaderImg"
  }, [_c('img', {
    staticClass: "align_center_screen",
    attrs: {
      "src": require("./assets/loader.gif"),
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "separatorBlock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "drpText"
  }, [_vm._v("Dropzone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align_middle"
  }, [_c('span', {
    staticClass: "separatorBlock sb32"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f498c9e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 166
// module chunks = 1